import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Chart, ChartType } from 'chart.js';
import { TileJSON } from 'ol/source';
import { PointsService } from 'src/app/services/points.service';
import { UserSpaceDTO } from 'src/app/models/UserSpaceDTO';
import { UtilsService } from 'src/app/services/utils.service';
import { Input } from '@angular/core';

@Component({
  selector: 'app-user-space',
  templateUrl: './user-space.component.html',
  styleUrls: ['../../../app.component.scss', 'user-space.component.scss'],
  standalone: false
})
export class UserSpaceComponent implements OnInit {
  isLoading = false;
  @Input() isAdminView: boolean = false;

  @ViewChild('allUserSpacesChart') allUserSpacesChart!: ElementRef<HTMLCanvasElement>;
  @ViewChild('userSpaceChart') userSpaceChart!: ElementRef<HTMLCanvasElement>;
  @ViewChild('calculationDatabaseChart') calculationDatabaseChart!: ElementRef<HTMLCanvasElement>;

  chart1!: Chart;
  chart2!: Chart;
  chart3!: Chart;

  totalUserSpaceAvailable = { value: 0 };
  calculationDatabaseSpaceAvailable = { value: 0 };
  allUserSpacesAvailable = { value: 0}

  constructor(public bsModalRef : BsModalRef,
    private pointsService: PointsService,
    public readonly utilsService: UtilsService
  ) { }

ngOnInit(): void {
  if (this.isAdminView) {
    this.isLoading = true;
    this.pointsService.getAllUserSpaces().subscribe(
      (userSpace: UserSpaceDTO) => {
        if (this.allUserSpacesChart) {
          this.createChart(userSpace, this.allUserSpacesAvailable, this.allUserSpacesChart, 'chart1');
        }
        this.isLoading = false;
      },
      () => { this.isLoading = false; }
    );
  } else {
    this.pointsService.getUserSpace().subscribe((result: { [key: string]: UserSpaceDTO }) => {
      if (this.userSpaceChart && this.calculationDatabaseChart) {
        this.createChart(result["userSpace"], this.totalUserSpaceAvailable, this.userSpaceChart, 'chart2');
        this.createChart(result["calculationDatabase"], this.calculationDatabaseSpaceAvailable, this.calculationDatabaseChart, 'chart3');
      }
    });
  }
}






  createChart(userSpaceDTO: UserSpaceDTO, availableSpace: {value: number}, canvasRef: ElementRef<HTMLCanvasElement>, chartField: 'chart1' | 'chart2' | 'chart3') {
    let usedSpaceInGB: number = userSpaceDTO.usedSpace / (1000 * 1000 * 1000);
    availableSpace.value = userSpaceDTO.totalSpace / (1000 * 1000 * 1000);
    let freeSpaceInGB: number = (userSpaceDTO.totalSpace - userSpaceDTO.usedSpace) / (1000 * 1000 * 1000);
    const ctx = canvasRef.nativeElement.getContext('2d');

    const dataSet = {
      labels: [
        'Free Space',
        'Used Space'
      ],
      datasets: [{
        label: 'User Data',
        data: [freeSpaceInGB, usedSpaceInGB],
        backgroundColor: [
          'rgb(220,220,220)',
          'rgb(135,206,250)',
        ],
        hoverOffset: 4
      }]
    };

    const config = {
      type: "doughnut" as ChartType,
      data: dataSet,
      options: {
        plugins: {
          legend: {
            display: true,
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                if (context.dataset.label != "wayPoints") {
                  return Math.round(context.dataset.data[context.dataIndex] * 100) / 100 + "GB";
                }
              }
            }
          }
        }
      }
    };

    if (this[chartField]) {
    this[chartField].destroy();
  }

    this[chartField] = new Chart(ctx!, config);
  }

  cancelUserSpaceModal():void {
    this.bsModalRef.hide();
  }
}
